module.exports = __webpack_public_path__ + "static/img/12.3f075a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/12.png
// module id = ryyY
// module chunks = 1